'use client'

import type { ReactNode } from 'react'
import { BlockStack, Text, Box } from '@shopify/polaris'

type Props = {
  title: string
  description?: string
  /** Optional muted icon (outline) */
  icon?: ReactNode
  action?: ReactNode
}

/**
 * Centered, text-forward empty state — matches premium analytics product tone.
 */
export function SigmaEmptyState({ title, description, icon, action }: Props) {
  return (
    <Box paddingBlockStart="800" paddingBlockEnd="800" paddingInline="400">
      <BlockStack gap="300" inlineAlign="center">
        {icon ? (
          <Box opacity="0.35" minHeight="40px">
            {icon}
          </Box>
        ) : null}
        <Text as="h2" variant="headingMd" alignment="center">
          {title}
        </Text>
        {description ? (
          <Text as="p" variant="bodyMd" tone="subdued" alignment="center">
            {description}
          </Text>
        ) : null}
        {action ? <Box paddingBlockStart="200">{action}</Box> : null}
      </BlockStack>
    </Box>
  )
}
